/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Media from 'react-media';
import { makeStyles } from '@material-ui/core/styles';
import Star from '@material-ui/icons/Star';
import StarHalf from '@material-ui/icons/StarHalf';
import useIsPlaPage from '../../../../../../../helpers/hooks/useIsPlaPage';

const useStyles = makeStyles((theme) => ({
    productRatingContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '0 0 10px',
        [theme.breakpoints.down(600)]: {
            justifyContent: 'flex-end',
            margin: 0,
        },
    },
    shopperApproveContainer: {
        height: '43px',
    },
    ratingStars: {
        display: 'inline-block',
        margin: '0 17px 0 0',
        height: '19px',
        '& svg': {
            width: '20px',
            height: 'auto',
            color: theme.palette.cms?.ratingStarsColor || '#E4984B',
        },
    },
    reviewCountContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '10px',
    },
    reviewCount: {
        display: 'inline-block',
        color: theme.palette.cms?.reviewCountColor || '#B6B6B6',
        fontSize: '15px',
        lineHeight: '14px',
    },
    shopperApproveIcon: {
        width: '119px',
        height: '39px',
        [theme.breakpoints.down(600)]: {
            width: '90px',
            height: '30px',
        },
    },
    plaProductRatingCOntainer: {
        '@media screen and (max-width: 1280px) and (min-width: 1026px)': {
            alignItems: 'start',
        },
        '& $reviewCountContainer': {
            '@media screen and (max-width: 1280px) and (min-width: 1026px)': {
                display: 'block',
            },
        },
        '& $reviewCount': {
            '@media screen and (max-width: 1280px) and (min-width: 1026px)': {
                display: 'block',
                margin: '0px',
            },
        },
    },
}));

const ShopperApprovedReviewIcon = () => {
    const classes = useStyles();
    const isPlaPage = useIsPlaPage();
    return (
        <div className={isPlaPage ? `${classes.plaProductRatingCOntainer} ${classes.productRatingContainer}` : classes.productRatingContainer}>
            <Media
                query="(min-width: 600px)"
                render={() => (
                    <div className={classes.reviewCountContainer}>
                        <div className={classes.ratingStars}>
                            <Star />
                            <Star />
                            <Star />
                            <Star />
                            <StarHalf />
                        </div>
                        <p className={classes.reviewCount}>(254,268 reviews)</p>
                    </div>
                )}
            />
            <div className={classes.shopperApproveContainer}>
                <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltab0819c5ba8dff60/5e28ea9fe2b3975498eaf8d3/salogo.png" className={classes.shopperApproveIcon} alt="Shopper Approved Logo" />
            </div>
        </div>
    );
};

export default ShopperApprovedReviewIcon;
